import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Modal from '../../../../../components-new/ui/Modal';
import Input from '../../../../../components-new/form/Input';
import SilverButton from '../../../../../components-new/buttons/SilverButton';
import BlueButton from '../../../../../components-new/buttons/BlueButton';
import LockKeyholeIcon from '../../../../../assets/icons/LockKeyholeIcon';
import Translate from '../../../../../components/Translate';
import config from '../../../../../config';
import {generalModalStyles} from '../../../../../utils/General';
import {updateMemberPassword} from '../../../../../services/company/api';
import {addNotification as addNotificationAction} from '../../../../../services/notification/action';
import '../../header/SettingsModal.css';

const EmployeePasswordModal = ({member, onClose, addNotification}) => {
    const [password, setPassword] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setPassword('');
        setSaving(false);
    }, [member]);

    if (!member) return null;

    const savePassword = () => {
        if (!password || saving) return;

        setSaving(true);
        updateMemberPassword(member.platformId, password)
            .then(() => {
                addNotification('passwordChanged', config.notificationLevels.success);
                onClose();
            })
            .catch((error) => {
                const message = error.response && error.response.data;
                addNotification(message || 'somethingWentWrong', config.notificationLevels.error);
            })
            .finally(() => setSaving(false));
    };

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen
            style={generalModalStyles.menuItemModalStyles}
            onRequestClose={saving ? undefined : onClose}
            onCancel={saving ? undefined : onClose}
            title={<Translate text="changePassword"/>}
            description={<Translate text="employeePasswordDescription"/>}
            headerIcon={<LockKeyholeIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
            headerSeparator
            footerSeparator
            footer={
                <React.Fragment>
                    <SilverButton type="button" width="auto" height="40px" disabled={saving} onClick={onClose}>
                        <Translate text="cancel"/>
                    </SilverButton>
                    <BlueButton type="button" width="auto" height="40px" loading={saving}
                                disabled={!password || saving} onClick={savePassword}>
                        <Translate text="save"/>
                    </BlueButton>
                </React.Fragment>
            }
        >
            <div className="settings-modal-fields">
                <Input
                    type="password"
                    label={<Translate text="newPassword"/>}
                    controlled
                    value={password}
                    maxLength={20}
                    style={{height: '40px'}}
                    onChange={(event) => setPassword(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') savePassword();
                    }}
                />
            </div>
        </Modal>
    );
};

EmployeePasswordModal.propTypes = {
    member: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
};

export default connect(null, {addNotification: addNotificationAction})(EmployeePasswordModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeePasswordModal.jsx